import { ReactNode } from "react";
import { Dialog } from "@mui/material";
import { useScale } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";

interface ParentModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  icon?: string;
  children: ReactNode;
}

export const ParentModal = ({ open, onClose, title, icon, children }: ParentModalProps) => {
  const { scale } = useScale();

  return (
    <Dialog
      fullScreen
      open={open}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el w-[1000px] border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white">
              <ParentCloseBtn close={onClose} />
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                {icon && (
                  <span className="material-symbols-outlined !text-[54px] text-red-100">
                    {icon}
                  </span>
                )}
                <h2 className="text-[33px] text-textcolor-black">{title}</h2>
              </div>

              <div className="flex-col-el gap-4 max-h-[700px] overflow-y-auto invisible-scrollbar">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
